import React from 'react';
import { observer } from 'mobx-react-lite';

var UserBlockFreeBet = observer(function (_a) {
    var freeBetCount = _a.freeBetCount, handleFreeBetOpen = _a.handleFreeBetOpen, notAllowToClick = _a.notAllowToClick; _a.children;
    return (React.createElement("div", { className: 'user-bonus', onClick: handleFreeBetOpen, style: notAllowToClick ? { pointerEvents: 'none' } : null },
        React.createElement("p", { className: 'user-bonus-amount' }, freeBetCount || '')));
});

export { UserBlockFreeBet };
